import { AuthService } from '../services/auth.service';
import { environment } from '../../../environments/environment';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({providedIn: 'root'})
export class BasicAuthInterceptor implements HttpInterceptor {
  constructor(public authService: AuthService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    // [AUTH-27] Only requests to our own API get the Bearer token — an absolute third-party URL
    // fetched through HttpClient must never receive the user's JWT. "Our own API" spans TWO
    // bases: apiUrl (/api controllers) AND minimalApiUrl (the testing minimal APIs at the domain
    // root) — matching only apiUrl broke the testee flow with a 401 on every /testing request.
    if (this.isOwnApiRequest(request.url) && this.authService.isAuthenticated()) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${this.authService.accessToken}`
        }
      });
    }
    return next.handle(request);
  }

  // In prod both bases are '' (the UI and API share an origin and the services build relative
  // URLs), and ''.startsWith('') is true for EVERY url — which attached the JWT to third-party
  // requests too. With no absolute bases configured, only relative URLs (same-origin by
  // definition) are ours; any absolute http(s) URL is third-party.
  private isOwnApiRequest(url: string): boolean {
    const bases = [environment.apiUrl, environment.minimalApiUrl].filter(base => !!base);

    if (bases.length > 0) {
      return bases.some(base => url.startsWith(base));
    }

    return !/^https?:\/\//i.test(url);
  }
}

